import React from 'react'

const FooterSection = () => (
  <footer className="bg-[#374151] text-white py-8">
    <div className="container mx-auto px-6">
      <div className="flex flex-wrap items-center justify-center gap-6 text-sm font-semibold">
        <a className="text-brand-lime" href="/">
          autoverkaufen.de
        </a>
        <span className="text-white/80">Die beste Wahl</span>
        <a className="hover:text-white transition" href="#faq">
          H&auml;ufige Fragen
        </a>
        <a className="hover:text-white transition" href="/kontakt">
          Kontakt
        </a>
        <a className="hover:text-white transition" href="/datenschutz">
          Datenschutz
        </a>
        <a className="hover:text-white transition" href="/impressum">
          Impressum
        </a>
        <a className="hover:text-white transition whitespace-nowrap" href="/agb">
          allgemeine Nutzungsbedingungen
        </a>
        <a className="bg-[#0099ff] hover:bg-[#007acc] text-white px-4 py-2 rounded-md transition" href="/cookies">
          Cookie-Einstellungen
        </a>
      </div>
    </div>
  </footer>
)

export default FooterSection
